// extracted by mini-css-extract-plugin
export default {"header":"staffPaymentDetails_header__fAi5G","title":"staffPaymentDetails_title__g9YYu"};